import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20artistic%20illustration%2C%20vibrant%20Korean%20manhwa%20characters%20in%20dynamic%20poses%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20stylized%20Korean%20comic%20art%20background%20with%20subtle%20texture%2C%20modern%20digital%20illustration%2C%20clean%20and%20artistic%20composition&width=1800&height=900&seq=hero-kr-comics&orientation=landscape"
        alt="韩国漫画在线 - 免费漫画阅读平台"
        title="韩国漫画在线 - 下拉式韩漫大全"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl font-heading text-white mb-4 md:mb-6 leading-tight">
          韩国漫画在线
        </h1>
        <p className="text-base md:text-xl text-white/90 mb-3 md:mb-4 max-w-2xl mx-auto leading-relaxed">
          免费漫画阅读平台 · 下拉式韩漫大全
        </p>
        <p className="text-sm md:text-base text-white/70 mb-6 md:mb-8 max-w-xl mx-auto">
          汇集海量韩国漫画资源，涵盖恋爱、奇幻、动作、悬疑、日常等分类，让漫画阅读变得丰富多彩而轻松
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/romance"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            开始阅读
          </Link>
          <Link
            to="/category/fantasy"
            className="px-8 py-3 bg-white/15 text-white border border-white/30 rounded-md font-medium text-sm hover:bg-white/25 transition-colors cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            探索分类
          </Link>
        </div>
      </div>
    </section>
  );
}